import controller from '../../Controller.js';
// import './Styles.css'; // imported from main bundle

function AutoComplete(input) {

    var searchContainer;
    var request = new XMLHttpRequest();
    var showCategories = false;

    function init() {
        showCategories = (input.getAttribute('data-show-categories') == 'true');
        input.addEventListener('input', handleSearch);
    }

    function handleSearch(e) {
        var query = this.value;
        showSearchContainerAndFetchResult(query);
    }

    function showSearchContainerAndFetchResult(query) {

        input.setAttribute('data-loading', 'true');
        fetchResult(query).then((result) => {

            if (!result.includes("autosuggest__result")) {
                hideSearchContainer();
                return;
            }

            input.setAttribute('data-loading', 'false');
            if (!searchContainer) {
                searchContainer = document.createElement('div');
                searchContainer.classList.add('autosuggest');
                input.insertAdjacentElement('afterend', searchContainer);
                document.body.addEventListener('click', hideSearchContainer);
                document.addEventListener('keydown', handleEscKeyPress);
                searchContainer.addEventListener('click', (e) => {
                    e.stopPropagation();
                });
            }
            else {
                searchContainer.classList.remove("hidden");
            }

            searchContainer.innerHTML = result;
            var autosuggestionItems = searchContainer.querySelectorAll('.autosuggest_suggestion');

            if (autosuggestionItems) {
                autosuggestionItems.forEach(function (item) {
                    item.addEventListener('click', handleSuggestionClick);
                });
            }

        });
    }

    function handleSuggestionClick(e) {
        input.value = this.textContent;
        var event = new KeyboardEvent('keyup');
        input.dispatchEvent(event);
        hideSearchContainer();
        //showSearchContainerAndFetchResult(this.textContent);
    }


    function fetchResult(query) {
        request.abort();
        var url = input.getAttribute('data-fetch-url');
        return new Promise((resolve, reject) => {
            request.onreadystatechange = function () {
                if (this.readyState !== 4) return;
                if (this.status === 500) {
                    reject();
                }
                if (this.status !== 200) return;
                resolve(this.responseText);
            };
            request.open('POST', url, true);
            request.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
            request.setRequestHeader('Content-Type', 'application/json');
            request.send(JSON.stringify({ query, showCategories }));
        });
    }

    function handleEscKeyPress(e) {
        if (e.keyCode == 27) {
            hideSearchContainer();
        }
    }

    function hideSearchContainer() {
        request.abort();
        input.setAttribute('data-loading', 'false');
        if (searchContainer) {
            searchContainer.classList.add('hidden');
            searchContainer.innerHTML = "";
        }
    }

    return {
        init: init
    }
}

controller.add('AutoComplete', AutoComplete);

export default AutoComplete;
